document.addEventListener("DOMContentLoaded", function() {
  function updateCountdown() {

    var now = moment().tz("America/Chicago");
    var cutoff = moment().tz("America/Chicago").hour(5).minute(0).second(0);

    if (now.hour() >= 5) {
      cutoff.add(1, 'day');
    }

    var diffInMinutes = cutoff.diff(now, 'minutes');

    if (diffInMinutes <= 0) {
      document.querySelectorAll("[data-time-remaining]").forEach(function(el){
        el.textContent = "0 hours 0 minutes";
      });
      return;
    }

    var hours = Math.floor(diffInMinutes / 60);
    var minutes = diffInMinutes % 60;

    var deliveryDate = moment().tz("America/Chicago");

    if (now.hour() >= 5) {
      deliveryDate.add(2, 'days');
    } else {
      deliveryDate.add(1, 'days');
    }

    var deliveryText = deliveryDate.format("dddd, MMMM D");
    var timeText = hours + " hours " + minutes + " minutes";

    document.querySelectorAll("[data-delivery-date]").forEach(function(el){
      el.textContent = deliveryText;
    });

    document.querySelectorAll("[data-time-remaining]").forEach(function(el){
      el.textContent = timeText;
    });
  }

  updateCountdown();
  setInterval(updateCountdown, 60000);
});
